<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md4 v-for="education in educationList" :key="education.id" class="px-1 py-1">
        <education-card :education="education"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    educationList: Array,
  },
};
</script>

<style scoped></style>
